import { useSelector } from "react-redux";

export const usePlatformConfigurations = (platformConfigurations = {}) => {
  const { integrations, lastSelectedIntegrationData } = useSelector(
    (state) => state.user
  );

  const getGoogleConfig = () => {
    const campaignConfig = platformConfigurations.google || {};
    const fallbackConfig = lastSelectedIntegrationData?.google || {};

    const googleIntegrations = integrations?.google || {};
    const hasGoogleIntegration = Object.keys(googleIntegrations).length > 0;

    return {
      integrationID:
        campaignConfig.integrationID ||
        fallbackConfig.integrationID ||
        (hasGoogleIntegration ? Object.keys(googleIntegrations)[0] : undefined),
      adAccountID:
        campaignConfig.adAccountID ||
        fallbackConfig.adAccountID ||
        (campaignConfig.integrationID &&
        googleIntegrations[campaignConfig.integrationID]?.businessAccounts
          ? Object.keys(
              googleIntegrations[campaignConfig.integrationID].businessAccounts
            )[0]
          : undefined) ||
        (fallbackConfig.integrationID &&
        googleIntegrations[fallbackConfig.integrationID]?.businessAccounts
          ? Object.keys(
              googleIntegrations[fallbackConfig.integrationID].businessAccounts
            )[0]
          : undefined),
    };
  };

  const getMetaConfig = () => {
    const campaignConfig = platformConfigurations.meta || {};
    const fallbackConfig = lastSelectedIntegrationData?.meta || {};

    const metaIntegrations = integrations?.facebook || {};
    const hasMetaIntegration = Object.keys(metaIntegrations).length > 0;

    const integrationID =
      campaignConfig.integrationID ||
      fallbackConfig.integrationID ||
      (hasMetaIntegration ? Object.keys(metaIntegrations)[0] : undefined);

    const metaIntegration = integrationID
      ? metaIntegrations[integrationID]
      : {};
    const metaPages = metaIntegration?.pages || {};
    const firstMetaPageID =
      Object.keys(metaPages).length > 0 ? Object.keys(metaPages)[0] : undefined;

    return {
      integrationID,
      adAccountID:
        campaignConfig.adAccountID ||
        fallbackConfig.adAccountID ||
        (integrationID && metaIntegrations[integrationID]?.businessAccounts
          ? Object.keys(metaIntegrations[integrationID].businessAccounts)[0]
          : undefined),
      pageID: campaignConfig.pageID || fallbackConfig.pageID || firstMetaPageID,
      instagramID: campaignConfig.instagramID || fallbackConfig.instagramID,
    };
  };

  const getTikTokConfig = () => {
    const campaignConfig = platformConfigurations.tiktok || {};
    const fallbackConfig = lastSelectedIntegrationData?.tiktok || {};

    const tiktokIntegrations = integrations?.tiktok || {};
    const hasTikTokIntegration = Object.keys(tiktokIntegrations).length > 0;

    return {
      integrationID:
        campaignConfig.integrationID ||
        fallbackConfig.integrationID ||
        (hasTikTokIntegration ? Object.keys(tiktokIntegrations)[0] : undefined),
      adAccountID:
        campaignConfig.adAccountID ||
        fallbackConfig.adAccountID ||
        (campaignConfig.integrationID &&
        tiktokIntegrations[campaignConfig.integrationID]?.businessAccounts
          ? Object.keys(
              tiktokIntegrations[campaignConfig.integrationID].businessAccounts
            )[0]
          : undefined) ||
        (fallbackConfig.integrationID &&
        tiktokIntegrations[fallbackConfig.integrationID]?.businessAccounts
          ? Object.keys(
              tiktokIntegrations[fallbackConfig.integrationID].businessAccounts
            )[0]
          : undefined),
    };
  };

  const getCanvaConfig = () => {
    const campaignConfig = platformConfigurations.canva || {};
    const fallbackConfig = lastSelectedIntegrationData?.canva || {};

    const canvaIntegrations = integrations?.canva || {};
    const firstActiveIntegrationId =
      canvaIntegrations?.id ||
      Object.entries(canvaIntegrations).find(
        ([, v]) => v && typeof v === "object" && v?.isActive
      )?.[0] ||
      Object.keys(canvaIntegrations)[0];

    return {
      integrationID:
        campaignConfig.integrationID ||
        fallbackConfig.integrationID ||
        firstActiveIntegrationId,
    };
  };

  const getGoogleDriveConfig = () => {
    const campaignConfig = platformConfigurations.googleDrive || {};
    const fallbackConfig = lastSelectedIntegrationData?.googleDrive || {};

    const googleDriveIntegrations = integrations?.googleDrive || {};
    const firstActiveIntegrationId =
      Object.entries(googleDriveIntegrations).find(
        ([, v]) => v && typeof v === "object" && v?.isActive
      )?.[0] || Object.keys(googleDriveIntegrations)[0];

    return {
      integrationID:
        campaignConfig.integrationID ||
        fallbackConfig.integrationID ||
        firstActiveIntegrationId,
    };
  };

  return {
    meta: getMetaConfig(),
    google: getGoogleConfig(),
    tiktok: getTikTokConfig(),
    canva: getCanvaConfig(),
    googleDrive: getGoogleDriveConfig(),
  };
};
